if (!customElements.get('multi-story')) {
  class MultiStory extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (window.Swiper) {
        this.init();
        this.addResizeListener();
        return;
      }
      document.addEventListener('load', (e) => {
        if (!e.target.closest('[data-swiper-script]')) return;
        
        this.init()
        this.addResizeListener();
      }); 
    }
  
    addResizeListener() {
      if (!this.isConnected) return;

      window.addEventListener('resize', debounce(() => {
        if (!this.classList.contains('swiper-initialized')) return;
        this.reinit();
      }), 1000);
    }

    reinit() {
      this.slider.destroy();
      this.init();
    }
    
    init() {    
      this.contentSlider = new Swiper(this.querySelector('[data-content-slider]'), {
        effect: "creative",
        allowTouchMove: false,
        navigation: {
          nextEl: this.querySelector('[data-next]'),
          prevEl: this.querySelector('[data-prev]'),
        },
        pagination: {
          el: this.querySelector('[data-pagination]'),
          type: 'fraction',
        },
        creativeEffect: {
          prev: { opacity: 0 },
          next: { opacity: 0 }
        }
      });
      
      this.mobileContentSlider = new Swiper(this.querySelector('[data-content-slider-mobile]'), {
        effect: "creative",
        allowTouchMove: false,
        creativeEffect: {
          prev: { opacity: 0 },
          next: { opacity: 0 }
        }
      });
      
      this.imageSlider = new Swiper(this.querySelector('[data-image-slider]'), {
        effect: "creative",
        navigation: {
          nextEl: this.querySelector('[data-next]'),
          prevEl: this.querySelector('[data-prev]'),
        },
        pagination: {
          el: this.querySelector('[data-bullets]'),
          type: 'bullets',
        },
        creativeEffect: {
          limitProgress: 2,
          progressMultiplier: 1.2,
          prev: {
            translate: ["-2.5%", 0, 0],
            scale: 0.9,
            opacity: 0.8,
            origin: "left"
          },
          next: {
            translate: ["2.5%", 0, 0],
            scale: 0.9,
            opacity: 0.8,
            origin: "right"
          },
        },
        breakpoints: {
          768: {
            creativeEffect: {
              limitProgress: 2,
              progressMultiplier: 1.2,
              prev: {
                translate: [0, "2.5%", 0],
                scale: 0.9,
                opacity: 0.8,
                origin: "bottom"
              },
              next: {
                translate: [0, "-2.5%", 0],
                scale: 0.9,
                opacity: 0.8,
                origin: "top"
              },
            }
          }
        }
      });
      
      this.imageSlider.on('slideChange', (e) => {
        this.mobileContentSlider?.slideTo(e.activeIndex, 0);
        this.contentSlider?.slideTo(e.activeIndex, 200);
      });      
    }
  }
  customElements.define('multi-story', MultiStory);
}
